"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigLinkDataNumberInput = exports.MenuConfigurationLinksData = void 0;
const react_1 = __importStar(require("react"));
const d3 = __importStar(require("d3"));
const SankeyDrawFunction_1 = require("../draw/SankeyDrawFunction");
const SankeyUtils_1 = require("./SankeyUtils");
const react_2 = require("@chakra-ui/react");
/*************************************************************************************************/
const MenuConfigurationLinksData = (dict_variable_application_data, dict_variable_elements_selected, applicationContext, additional_data_element, ComponentUpdater, node_function, link_function) => {
    const { t } = applicationContext;
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    const { data } = dict_variable_application_data;
    const { multi_selected_links, displayedInputLinkValueSetterRef, displayedInputLinkValueRef, displayedInputLinkDataTagSetterRef } = dict_variable_elements_selected;
    const [displayed_input_link_value, set_displayed_input_link_value] = (0, react_1.useState)('');
    displayedInputLinkValueSetterRef.current.push(set_displayed_input_link_value);
    displayedInputLinkValueRef.current = displayed_input_link_value;
    const newEntries = new Map(Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
        return (Object.keys(dataTag.tags).length > 0) ? [
            dataTagKey,
            Object.entries(dataTag.tags).filter(tag => tag[1].selected).length > 0 ? Object.entries(dataTag.tags).filter(tag => tag[1].selected)[0][0] : Object.keys(dataTag.tags)[0]
        ] : ['n', 'n'];
    }));
    const dataTagsSelected = Object.fromEntries(newEntries);
    const [tags_selected, set_tags_selected] = (0, react_1.useState)(dataTagsSelected);
    displayedInputLinkDataTagSetterRef.current.push(set_tags_selected);
    if (Object.keys(tags_selected).length !== Object.keys(dataTagsSelected).length) {
        set_tags_selected(dataTagsSelected);
    }
    const content = react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_grid' }, // Définition des valeurs selon les paramètre dataTags
        Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
            if (Object.keys(dataTag.tags).length != 0) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_part_title_3' }, dataTag.group_name),
                    react_1.default.createElement(react_2.Select, { name: dataTagKey, variant: 'menuconfigpanel_option_select', value: tags_selected[dataTagKey], onChange: (evt) => {
                            //Modifie les paramètres selectionnés
                            const { name, value } = evt.target;
                            let tmp = {};
                            // set_tags_selected( prevState => {
                            tmp = (Object.assign(Object.assign({}, tags_selected), { [name]: value }));
                            set_tags_selected(tmp);
                            //   return ({...prevState,[name]: value}) 
                            // } )
                            displayedInputLinkValueSetterRef.current.forEach(setter => setter((0, SankeyDrawFunction_1.ValueSelectedParameter)(dict_variable_application_data, multi_selected_links, tmp).value));
                        } }, Object.entries(dataTag.tags).map(([tag_key, tag]) => {
                        return (react_1.default.createElement("option", { key: tag.name, value: tag_key }, tag.name));
                    }))));
            }
        }),
        react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Flux.data.tooltips.vpp') },
            react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols' },
                react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_option_name' }, t('Flux.data.vpp')),
                react_1.default.createElement(exports.ConfigLinkDataNumberInput, { dict_variable_application_data: dict_variable_application_data, multi_selected_links: multi_selected_links, tags_selected: tags_selected, node_function: node_function, link_function: link_function, ComponentUpdater: ComponentUpdater }))),
        react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Flux.data.tooltips.affichage') },
            react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols' },
                react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_option_name' }, t('Flux.data.affichage')),
                react_1.default.createElement(react_2.InputGroup, { variant: 'menuconfigpanel_option_input' },
                    react_1.default.createElement(react_2.Input, { variant: 'menuconfigpanel_option_input', value: (0, SankeyDrawFunction_1.ValueSelectedParameter)(dict_variable_application_data, multi_selected_links, tags_selected).display_value, onChange: evt => {
                            let val = Object(multi_selected_links.current[0].value);
                            multi_selected_links.current.map(d => {
                                val = d.value;
                                Object.values(tags_selected).forEach(tag => {
                                    if (val[tag] === undefined) {
                                        val[tag] = {};
                                    }
                                    val = val[tag];
                                });
                                val.display_value = evt.target.value;
                            });
                            setForceUpdate(!forceUpdate);
                            link_function.RedrawLinks(multi_selected_links.current);
                        } })))),
        additional_data_element);
    return [content];
};
exports.MenuConfigurationLinksData = MenuConfigurationLinksData;
/**
 * Component developped for number input of the layout config menu
 *
 * @param {SankeyData} data
 * @param {keyof SankeyData} var_of_data keyof of the variable we want to reference in the inputn the variable in SankeyData need to be a number
 * @param {number} minimum_value (optional, if not specified it mean the value can be undefined )
 * @param {boolean} stepper (default:false) add stepper to the input to increase or decrease the value
 * @param {boolean} hasUnit (default:false) add an addon after the input
 * @param {string} unitText (default:'') text of the addon
 * @param {function} function_onBlur function called when we leave the input, it is generally used to update the draw area
 *
 * @return {JSX.Elmement}
 */
const ConfigLinkDataNumberInput = ({ dict_variable_application_data, multi_selected_links, tags_selected, node_function, link_function, ComponentUpdater, }) => {
    const { data } = dict_variable_application_data;
    const [update, setUpdate] = (0, react_1.useState)(false);
    const ref_input = (0, react_1.useRef)(null);
    const variantOfInput = 'menuconfigpanel_option_numberinput';
    const val_of_key = (0, SankeyDrawFunction_1.ValueSelectedParameter)(dict_variable_application_data, multi_selected_links, tags_selected);
    // Add stepper addon if specified
    const stepperBtn = react_1.default.createElement(react_2.NumberInputStepper, null,
        react_1.default.createElement(react_2.NumberIncrementStepper, null),
        react_1.default.createElement(react_2.NumberDecrementStepper, null));
    return react_1.default.createElement(react_2.InputGroup, { variant: 'menuconfigpanel_option_input' },
        react_1.default.createElement(react_2.NumberInput, { allowMouseWheel: true, variant: variantOfInput, step: 1, value: val_of_key.value, onChange: evt => {
                console.trace('here');
                const formatedValue = evt.replace(',', '.');
                if (formatedValue !== '' && !isNaN(+formatedValue)) {
                    const was_empty = (0, SankeyDrawFunction_1.ValueSelectedParameter)(dict_variable_application_data, multi_selected_links, tags_selected).value === '';
                    let val = Object(multi_selected_links.current[0].value);
                    const node_to_update = [];
                    multi_selected_links.current.map(d => {
                        node_to_update.push(data.nodes[d.idSource]);
                        node_to_update.push(data.nodes[d.idTarget]);
                        const dashed = (0, SankeyUtils_1.ReturnValueLink)(data, multi_selected_links.current[0], 'dashed');
                        (0, SankeyUtils_1.AssignLinkLocalAttribute)(d, 'dashed', (was_empty) ? false : dashed);
                        val = d.value;
                        Object.values(tags_selected).forEach(tag => {
                            if (val[tag] === undefined) {
                                val[tag] = {};
                            }
                            val = val[tag];
                        });
                        val.value = +formatedValue;
                    });
                    const scale = d3.scaleLinear()
                        .domain([0, data.user_scale])
                        .range([0, 100]);
                    if (scale(+formatedValue) > 500) {
                        data.user_scale = +formatedValue;
                    }
                }
                else if (formatedValue == '') {
                    let val = Object(multi_selected_links.current[0].value);
                    const node_to_update = [];
                    multi_selected_links.current.map(d => {
                        node_to_update.push(data.nodes[d.idSource]);
                        node_to_update.push(data.nodes[d.idTarget]);
                        val = d.value;
                        (0, SankeyUtils_1.AssignLinkLocalAttribute)(d, 'dashed', true);
                        Object.values(tags_selected).forEach(tag => {
                            if (val[tag] === undefined) {
                                val[tag] = {};
                            }
                            val = val[tag];
                        });
                        val.value = '';
                    });
                }
                setUpdate(!update);
            }, onBlur: () => {
                node_function.RedrawNodes(Object.values(dict_variable_application_data.display_nodes));
                link_function.RedrawLinks(Object.values(dict_variable_application_data.display_links));
                ComponentUpdater.updateComponenSaveInCache.current(false);
            } },
            react_1.default.createElement(react_2.NumberInputField, { ref: ref_input }),
            stepperBtn));
};
exports.ConfigLinkDataNumberInput = ConfigLinkDataNumberInput;
